import { lazy } from "react";
import RoleSelectorDialog from "./components/RoleSelectorDialog";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const ChangePasswordPage = lazy(() => import("./pages/ChangePasswordPage"));

export { LoginPage, ChangePasswordPage, RoleSelectorDialog };

export const loginV2Routes = [
  { path: "/Login", element: <LoginPage /> },
  { path: "/auth/change-password", element: <ChangePasswordPage /> },
];
